// import miment from "miment";
import { getData } from "@/api/bigscreen";
import { getApplyData } from "@/api/basicCyberData";
import {  getPreviewOuter, getPreviewInternal } from "@/api/shareModal"
import { barOrLineChartFn } from "@/utils/modelMethods";
import { inject } from "vue";

const dataCache = new Map();
function getQueryString(name) {
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  let r = window.location.search.substr(1).match(reg);
  if (r != null) {
      return decodeURIComponent(r[2]);
  };
  return null;
}
export default {
  data() {
    return {
      // form select-input key
      selectInput: {
        keyname: "",
        keyword: "",
      },
      onceFlag: false,
    };
  },
  computed: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {
    // 把selectInput中的值赋到params查询对象中
    parseParamsBySelectInput(keyname, keyword) {
      if (this.params === undefined || this.params === null) {
        console.warn("query form must bind to params object in vue data");
        return;
      }
      // if (!this.params.hasOwnProperty(keyname)) {
      //   console.warn('params has no field:' + keyname)
      //   return
      // }
      if (keyword !== undefined) {
        this.params[keyname] = keyword.trim();
      }
    },
    resetForm(data) {
      let formKeys = Object.keys(data);
      for (let k of formKeys) {
        data[k] = null;
      }
    },
    async getCacheApplyData(params, odataParams){
      let path = this.$route.path
      let oParams = {
        ...odataParams,
        globalOptions: {
          globalDataSource: this.dashbordData.datasource,
          globalTableId: this.dashbordData.tableId,
          globalFilterType: this.dashbordData.filterType,
          globalAccountIds: this.dashbordData.accountIds,
          globalConditions: odataParams?.globalOptions?.globalConditions || [],
        }
      }
      console.log(oParams, 'oParams123123')
      let key = JSON.stringify({
        params, 
        odataParams: oParams,
      });
      let res = {}
      let data = dataCache.get(key);
      if(!data) {
        if(path === '/noPermissionView') {
          const reportCode = getQueryString('reportCode');
          params.id = reportCode;
          res = await getPreviewOuter(params, oParams);
        }else if(path === '/multiplePermissions') {
          const reportCode = getQueryString('reportCode');
          params.id = reportCode;
          res = await getPreviewInternal(params, oParams);
        }else {
          res = await getApplyData(params, oParams);
        }
        this.$store.commit("modelDesign/SET_COM_CACHE", {isCache: false})
        if(res.code === 200){
          dataCache.set(key, res.data);
        }
      }else {
        this.$store.commit("modelDesign/SET_COM_CACHE", {isCache: true})
        res = {data, code: 200}
      }
      return res;
    },
    getDatasource(dParams) {
      let dataParams = this.$deepclone(dParams)
      // dataParams.datasource = dataParams.datasource || this.dashbordData.datasource
      // if(!dataParams?.datasource) {
      //   dataParams.tableId = dataParams.tableId || this.dashbordData.tableId
      // }
      // if(!dataParams?.datasource && !dataParams?.tableId) {
      //   dataParams.filterType = dataParams.filterType || this.dashbordData.filterType
      // }
      // if(!dataParams?.datasource && !dataParams?.tableId && !dataParams.filterType) {
      //   dataParams.accountIds = dataParams.accountIds || this.dashbordData.accountIds
      // }
      return dataParams
    },
    // 查询echarts 数据
    queryEchartsData(dParams, params, chartProperties, pageParams = null) {
      this.$store.commit("modelDesign/SET_APPLY_LOADING", true);
      // 由于组件类型不同--》不同的数据结构，所以这里需要把组件类型传进来，然后根据组件类型获取不同的数据结构
      let dataParams = this.getDatasource(dParams)
      try {
        const filterCondition = this.getFilterCondition()
        if(filterCondition&&filterCondition.length) {
          dataParams.globalOptions = {
            globalConditions: filterCondition
          }
        }
      } catch (error) {
        console.log(error)
      }
      console.log(params, dataParams, 'dataParams')
      return new Promise(async (resolve, reject) => {
        try {
          const odataParams = {
            ...dataParams,
          };
          if (params.widgetType == "widget-table") {
            odataParams.pageNum = pageParams.pageNum;
            odataParams.pageSize = pageParams.pageSize;
          } else {
            odataParams.pageSize = 1000;
          }
          const res = await this.getCacheApplyData(params, odataParams);
          const {code, data } =res;
          chartProperties.isVerified = false;
          chartProperties.isDrag = false;
          this.$store.commit("modelDesign/SET_APPLY_LOADING", false);
          if (code != 200) return;
          if(!data.result&&data.result !== 0) {
            this.$message.warning("没有查询到数据");
            reject(data)
            return
          }
          const resData = this.analysisChartsData(params, dataParams, data);
          resolve(resData);
        } catch (error) {
          console.log(error)
          chartProperties.isVerified = false;
          this.$store.commit("modelDesign/SET_APPLY_LOADING", false);
          reject(error)
        }
      });
    },
    // 判断是否有组件内部日期
    isContCompDate(optionsData){
      const contextData = optionsData.dynamicData.contextData
      return contextData.dateRang && contextData.dateRang.from
    },
    // 解析不同图标的数据
    analysisChartsData({ widgetType, chartProperties }, dataParams, data) {
      // widget-barchart 柱状折线图、widget-linechart 折线图、 widget-barlinechart 柱状折线图
      // widget-piechart 饼图、widget-funnel 漏斗图
      // widget-text 文本框
      // widge-table 表格(数据不要转)
      // widget-stackchart 堆叠图
      if (
        widgetType == "widget-barchart" ||
        widgetType == "widget-linechart" ||
        widgetType == "widget-barlinechart"
      ) {
        if(data.axis.length === 0) {
          this.$message.warning("没有查询到数据");
        }
        let chartData = barOrLineChartFn(widgetType, dataParams, data);
        console.log(chartData, 'chartData')
        return chartData
      } else if (
        widgetType == "widget-piechart"
      ) {
        return this.piechartFn(data, widgetType);
      } else if (widgetType == "widget-text") {
        return this.widgettext(chartProperties, data);
      } else if (widgetType == "widget-stackchart") {
        return this.stackChartFn(chartProperties, data);
      } else {
        return data;
      }
    },
    //堆叠图
    stackChartFn(chartProperties, data) {
      const ananysicData = {};
      const series = [];
      //全部字段字典值
      const types = Object.values(chartProperties);
      //x轴字段、y轴字段名
      const xAxisField = Object.keys(chartProperties)[types.indexOf("xAxis")];
      const yAxisField = Object.keys(chartProperties)[types.indexOf("yAxis")];
      const dataField = Object.keys(chartProperties)[types.indexOf("bar")];
      //x轴数值去重，y轴去重
      const xAxisList = this.setUnique(data.map((item) => item[xAxisField]));
      const yAxisList = this.setUnique(data.map((item) => item[yAxisField]));
      const dataGroup = this.setGroupBy(data, yAxisField);
      for (const key in chartProperties) {
        if (
          chartProperties[key] !== "yAxis" &&
          !chartProperties[key].startsWith("xAxis")
        ) {
          Object.keys(dataGroup).forEach((item) => {
            const data = new Array(yAxisList.length).fill(0);
            dataGroup[item].forEach((res) => {
              data[xAxisList.indexOf(res[xAxisField])] = res[key];
            });
            series.push({
              name: yAxisList[item],
              type: chartProperties[key],
              data: data,
            });
          });
        }
      }
      ananysicData["xAxis"] = xAxisList;
      ananysicData["series"] = series;
      return ananysicData;
    },
    // 饼图、漏斗图
    piechartFn(data, chartType) {
      const ananysicData = [];
      if (data && data.result && data.result.length >0 && data.fields) {
        data.result.forEach((item, index) => {
          let o = data.fields.find(v => v.field === item.field)
          const obj = {};
          obj.symbol = o?.fieldUnit?.symbol || ''
          if(chartType == "widget-funnel"){
            obj.name =  data.fields && data.fields.length >0 ? data.fields[index].name : item.name;
            // obj.name = item.name;
          }else {
            obj.name = item.name;
          }
          obj.value = item.value;
          obj.field = item.field;
          ananysicData.push(obj);
        });
      }
      
      return ananysicData;
    },
    widgettext(chartProperties, data) {
      const ananysicData = [];
      for (let i = 0; i < data.length; i++) {
        const obj = {};
        for (const key in chartProperties) {
          const value = chartProperties[key];
          if (value === "name") {
          } else {
            obj["value"] = data[i][key];
          }
        }
        ananysicData.push(obj);
      }
      return ananysicData;
    },
    setUnique(arr) {
      let newArr = [];
      arr.forEach((item) => {
        return newArr.includes(item) ? "" : newArr.push(item);
      });
      return newArr;
    },
    setGroupBy(array, name) {
      const groups = {};
      array.forEach(function (o) {
        const group = JSON.stringify(o[name]);
        groups[group] = groups[group] || [];
        groups[group].push(o);
      });
      return Object.keys(groups).map(function (group) {
        return groups[group];
      });
    }
  },
  watch: {
    "selectInput.keyname"(newVal, oldVal) {
      this.resetForm(this.params);
      this.params.currentPage = 1;
      this.params.pageSize = 10;
      this.parseParamsBySelectInput(newVal, this.selectInput.keyword);
    },
    "selectInput.keyword"(newVal, oldVal) {
      if (!this.selectInput.keyname) return;
      this.parseParamsBySelectInput(this.selectInput.keyname, newVal);
    },
  },
};
